import {graphql, Link, useStaticQuery} from "gatsby";
import {FaBars} from "react-icons/fa";
import React, {useState} from "react";

const Header = () => {

  const [menuOpen, setMenuOpen] = useState(false);

  const data = useStaticQuery(graphql`
    query HeaderQuery {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `);

  const links = [
    { url: '/', label: 'Tagesablauf' },
    { url: '/rsvp', label: 'RSVP' },
    { url: '/hotels', label: 'Hotels' },
    { url: '/geschenke', label: 'Geschenkideen' },
    { url: '/kontakt', label: 'Weitere Infos' },
    { url: '/fotos', label: 'Fotos' }
  ];

  const handleMenuClick = (ev) => {
    ev.preventDefault();
    setMenuOpen(!menuOpen);
  }

  return (
    <header>
      <div className="box-border flex items-center justify-between sm:flex-col sm:justify-center py-4 sm:pb-6 px-4 bg-white">
        <Link className="font-pretty text-xl leading-10 sm:leading-15" to="/">{data.site.siteMetadata.title}</Link>
        <button onClick={handleMenuClick}><FaBars className="text-xl sm:hidden"/></button>
        <div className="hidden sm:flex sm:justify-around text-primary md:justify-between flex-wrap">
          {
            links.map(link => <Link key={link.url} className="text-xl mx-4 my-2" to={link.url}>{link.label}</Link>)
          }
        </div>

      </div>
      {
        <div className={`${!menuOpen ? "max-h-0 p-0" : "max-h-96 pb-2"} sm:hidden bg-white flex flex-col items-center text-primary transition-max-h duration-200 overflow-hidden`}>
          {
            links.map(link => <Link key={link.url} className="text-xl mx-4 my-2" to={link.url}>{link.label}</Link>)
          }
        </div>
      }
    </header>
  );
}

export default Header;
